import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { registerLicense } from '@syncfusion/ej2-base';
import { AllCommunityModule, ModuleRegistry } from 'ag-grid-community';

ModuleRegistry.registerModules([AllCommunityModule]);

// Registering Syncfusion license key
try {
  registerLicense('Ngo9BigBOggjHTQxAR8/V1JHaF5cWWdCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdlWXtfd3ZXQ2dcWEJyWUdWYEo=');
} catch (error) {
  console.warn('Syncfusion license registration failed:', error);
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));